/**
 * Références des enums de l'API (nom du cas, ex. EMPLOYEE) : la clé utilisée par le front, plutôt que l'id.
 * Libellés et ids viennent de l'API (useReferenceOptions / resolveReference), jamais du front.
 */
export const APP_ROLE = { ADMIN: 'ADMIN', USER: 'USER' } as const;
export const USER_STATUS = { ENABLED: 'ENABLED', DISABLED: 'DISABLED' } as const;
export const COMPANY_ROLE = { DIRECTOR: 'DIRECTOR', ASSISTANT: 'ASSISTANT', EMPLOYEE: 'EMPLOYEE' } as const;
export const TEAM_ROLE = { MANAGER: 'MANAGER', TEAMMATE: 'TEAMMATE' } as const;
export const TEAM_STATUS = { ACTIVE: 'ACTIVE', ARCHIVED: 'ARCHIVED' } as const;
export const TEAM_MEMBER_STATUS = { ACTIVE: 'ACTIVE', INACTIVE: 'INACTIVE' } as const;
export const PERIOD_STATUS = { OPEN: 'OPEN', CLOSED: 'CLOSED' } as const;
export const TIME_SHEET_STATUS = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  PENDING_MANAGER: 'PENDING_MANAGER',
  PENDING_DIRECTOR: 'PENDING_DIRECTOR',
  VALIDATED: 'VALIDATED',
  REJECTED: 'REJECTED',
} as const;

/** Exports des feuilles (Historique, icône Téléchargements) */
export const EXPORT_TYPE = { SUMMARY: 'SUMMARY', DETAILED: 'DETAILED', PDF_ZIP: 'PDF_ZIP' } as const;
export const EXPORT_STATUS = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
} as const;
export type ExportTypeReference = (typeof EXPORT_TYPE)[keyof typeof EXPORT_TYPE];

export type AppRoleReference = (typeof APP_ROLE)[keyof typeof APP_ROLE];
export type UserStatusReference = (typeof USER_STATUS)[keyof typeof USER_STATUS];
export const TIME_SHEET_TYPE = { NORMAL: 'NORMAL', ABSENCE: 'ABSENCE' } as const;
export const TIME_SHEET_SIGNATURE_TYPE = { EMPLOYEE: 'EMPLOYEE', MANAGER: 'MANAGER', DIRECTOR: 'DIRECTOR' } as const;
export type TimeSheetSignatureTypeReference =
  (typeof TIME_SHEET_SIGNATURE_TYPE)[keyof typeof TIME_SHEET_SIGNATURE_TYPE];

export type CompanyRoleReference = (typeof COMPANY_ROLE)[keyof typeof COMPANY_ROLE];
export type TimeSheetStatusReference = (typeof TIME_SHEET_STATUS)[keyof typeof TIME_SHEET_STATUS];
